module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/i8KofR/tc-custom/scover.jpg?1717896440992",
      "alt": "This image is the cover for the book Everything Self-Esteem Book, The Everything Books"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Everything Self-Esteem Book, The Everything Books\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("If you're looking to completely change how you feel about yourself, "), _c('i', [_vm._v("The Everything Self-Esteem Book")]), _vm._v(" is the perfect guide to help you gain a positive attitude and brim with confidence. Noted speaker and educator Robert M. Sherfield, Ph.D., provides you with encouraging professional advice on how to build self-esteem through developing a positive mindset, defining your personal joys, and learning from and celebrating mistakes."), _c('br'), _c('i', [_vm._v("The Everything Self-Esteem Book")]), _vm._v(" shows you how to:recognize behavior that reduces self-esteemset goals that workbuild confidence at home and in the workplacefind happiness in all areas of your lifetake positive risksidentify and eliminate people who bring you downand more"), _c('br'), _vm._v("Whether you want to overhaul your life and build a positive sense of self-worth or are just preparing for the journey, "), _c('i', [_vm._v("The Everything Self-Esteem Book")]), _vm._v(" is an essential guide to help you realize a healthier life.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robert M. Sherfield\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Adams Media, Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0